document.addEventListener('DOMContentLoaded', () => {
  // 1. Inicjalizacja Video Observera
  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play().catch(() => {});
        } else {
          entry.target.pause();
        }
      });
    },
    { threshold: 0.5 },
  );

  const videos = document.querySelectorAll(
    'video:not(.portfolio__item-video):not(.starter__video)',
  );
  videos.forEach((video) => videoObserver.observe(video));

  if (typeof initMobileMenu === 'function') initMobileMenu();

  // Mac trackpad generuje wiele małych eventów (szybkie) — niższy multiplier.
  // Windows mysz generuje rzadkie duże eventy — wyższy multiplier.
  const isMac = /Mac/i.test(navigator.userAgentData?.platform ?? navigator.platform);
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    wheelMultiplier: isMac ? 0.8 : 1.4,
    normalizeWheel: true,
    autoRaf: false,
  });

  if (typeof gsap !== 'undefined') {
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
  }

  if (typeof ScrollTrigger !== 'undefined') {
    lenis.on('scroll', ScrollTrigger.update);
  }

  window.__lenis = lenis;
});
